module.exports = __webpack_public_path__ + "img/Z60_05.5ea57fbb.jpg";